import { PermissionCheckerService } from 'abp-ng2-module';
import { AppSessionService } from '@shared/common/session/app-session.service';
import { Injectable } from '@angular/core';
import { AppMenu } from './app-menu';
import { AppMenuItem } from './app-menu-item';

@Injectable()
export class AppNavigationService {
    constructor(
        private _permissionCheckerService: PermissionCheckerService,
        private _appSessionService: AppSessionService
    ) { }



    getMenu(): AppMenu {
        return new AppMenu('MainMenu', 'MainMenu', [
            new AppMenuItem(
                'Dashboard',
                'Pages.Administration.Host.Dashboard',
                'flaticon-line-graph',
                '/app/admin/hostDashboard'
            ),
            new AppMenuItem('Dashboard', 'Pages.Tenant.Dashboard', 'flaticon-line-graph', '/app/main/dashboard'),
            new AppMenuItem(
                'Saas',
                '',
                'flaticon-users',
                '',
                [],
                [
                    new AppMenuItem('Tenants', 'Pages.Tenants', 'flaticon-list-3', '/app/admin/tenants'),
                    new AppMenuItem('Editions', 'Pages.Editions', 'flaticon-app', '/app/admin/editions'),
                ]
            ),
            new AppMenuItem(
                'Referral and Assessment',
                'Pages.Referrals',
                'flaticon-avatar',
                '',
                [],
                [
                    new AppMenuItem('Referral', 'Pages.Referrals', 'fa fa-user-friends', '/app/main/referrals/referrals'),
                    new AppMenuItem('Biopsychosocial Assessment', 'Pages.IntakeClients', 'fa fa-users', '/app/main/intakeClients'),
                    new AppMenuItem('Psychiatric Evaluation', 'Pages.PsycEvalses', 'fa fa-tasks', '/app/main/psycEval/psycEvalses'),
                                    new AppMenuItem('Health Home Assessment', 'Pages.HealthHomes', 'la la-university', '/app/main/healthHomes/healthHomes'),

                    new AppMenuItem('Daily Living Activities', 'Pages.DLAs', 'fa fa-medkit', '/app/main/dla/dlAs'),

                ]
            ),

            new AppMenuItem(
                'Client Profile',
                'Pages.Clients',
                'm-menu__link-icon flaticon-profile-1',
                '/app/main/clients/clients'
            ),
            new AppMenuItem(
                'Plans',
                '',
                'flaticon-list',
                '',
                [],
                [
                    new AppMenuItem('Service Plan', 'Pages.TreatmentPlans', 'fa fa-cogs', '/app/main/treatmentPlans/treatmentPlans'),
                    new AppMenuItem('Discharge Summary', 'Pages.DischargeSummaries', 'fa fa-notes-medical', '/app/main/dischargeSummaries/dischargeSummaries'),
                    //new AppMenuItem('Transition Continuing Care Plan', 'Pages.TransitionCarePlans', 'fa fa-object-group', '/app/main/transitionCarePlans/transitionCarePlans'),
                    new AppMenuItem('PersonalSafetyPlans', 'Pages.PersonalSafetyPlans', 'fa fa-book', '/app/main/personalSafetyPlan/personalSafetyPlans'),
                ]
            ),

            //  
            new AppMenuItem('Services', '', 'flaticon-menu-2', '', [],
                [
                    new AppMenuItem('Med Management', 'Pages.MedManagment', 'fas fa-notes-medical', '/app/main/medManagement'),
                    new AppMenuItem('Individual Clinic Contact Note', 'Pages.IndividualClinicalNotes', 'fa fa-address-card', '/app/main/individualClinicalNotes/individualClinicalNote'),
                    new AppMenuItem('Group Contact Note', 'Pages.GroupContactNotes', 'fa fa-users', '/app/main/groupContactNotes/groupContactNotes'),
                    new AppMenuItem('Rehab Individual Note', 'Pages.RehabNotes', 'fa fa-retweet', '/app/main/rehabNotes/rehabNotes'),

                ]),

            new AppMenuItem('Client Chart Drop Off', 'Pages.Sharepoint', 'fa fa-file', '/app/main/clientChartDropOff'),


            new AppMenuItem('Vitals', 'Pages.Vitals', 'fa fa-heart', '/app/main/vitals/vitals'),

            new AppMenuItem('IndividualNotes', 'Pages.IndividualNotes', 'fa fa-book', '/app/main/individualNotes/indualNotes'),

            new AppMenuItem('Rehab Progress Notes', 'Pages.RehabProgrssNotes', 'fa fa-book', '/app/main/rehabProgressNote/rehabProgressNotes'),





            // new AppMenuItem('DlaSupplementals', 'Pages.DlaSupplementals', 'flaticon-more', '/app/main/dlaSupplemental/dlaSupplementals'),


            //new AppMenuItem('ClientPractitioners', 'Pages.ClientPractitioners', 'flaticon-more', '/app/main/clientPractitioners/clientPractitioners'),

            // new AppMenuItem(
            //     'PracLicenceRateMasters',
            //     'Pages.PracLicenceRateMasters',
            //     'flaticon-more',
            //     '/app/main/administration/pracLicenceRateMasters'
            // ),





            // new AppMenuItem(
            //     'Acknowledgements',
            //     'Pages.Acknowledgements',
            //     'flaticon-more',
            //     '/app/main/acknowledgement/acknowledgements'
            // ),

            // new AppMenuItem('ShortGoals', 'Pages.ShortGoals', 'flaticon-more', '/app/main/treatmentPlans/shortGoals'),

            // new AppMenuItem('LongGoals', 'Pages.LongGoals', 'flaticon-more', '/app/main/longGoals/longGoals'),

            // new AppMenuItem('DemoReferrals', 'Pages.DemoReferrals', 'flaticon-more', '/app/main/demoTemplate/demoReferrals'),

            // new AppMenuItem('TreatmentDiagnosises', 'Pages.TreatmentDiagnosises', 'flaticon-more', '/app/main/treatment/treatmentDiagnosises'),

            // new AppMenuItem('TransitionPlans', 'Pages.TransitionPlans', 'flaticon-more', '/app/main/transitionPlan/transitionPlans'),



            // new AppMenuItem('DischargePlans', 'Pages.DischargePlans', 'flaticon-more', '/app/main/dischargePlans/dischargePlans'),

            // new AppMenuItem('SupportServices', 'Pages.SupportServices', 'flaticon-more', '/app/main/supportServices/supportServices'),

            // new AppMenuItem(
            //     'TreatmentModes',
            //     'Pages.TreatmentModes',
            //     'flaticon-more',
            //     '/app/main/treatmentMode/treatmentModes'
            // ),

            // new AppMenuItem(
            //     'DemoReferralMedicationses',
            //     'Pages.DemoReferralMedicationses',
            //     'flaticon-more',
            //     '/app/main/demoTemplate/demoReferralMedicationses'
            // ),

            //   new AppMenuItem('ReferralMedications', 'Pages.ReferralMedications', 'flaticon-more', '/app/main/workFlow/referralMedications'),

            //  new AppMenuItem('ReferralAllergies', 'Pages.ReferralAllergies', 'flaticon-more', '/app/main/workFlow/referralAllergies'),

            // new AppMenuItem(
            //     'AllergyMasters',
            //     'Pages.AllergyMasters',
            //     'flaticon-more',
            //     '/app/main/workFlow/allergyMasters'
            // ),

            // new AppMenuItem(
            //     'ReferralMedications',
            //     'Pages.ReferralMedications',
            //     'flaticon-more',
            //     '/app/main/workFlow/referralMedications'
            // ),


            // new AppMenuItem(
            //     'MedicationMasters',
            //     'Pages.MedicationMasters',
            //     'flaticon-more',
            //     '/app/main/workFlow/medicationMasters'
            // ),

            //new AppMenuItem(
            //    'ReferralPayers',
            //    'Pages.ReferralPayers',
            //    'flaticon-more',
            //    '/app/main/referralPayers/referralPayers'
            //),

            //new AppMenuItem(
            //    'ReferralSources',
            //    'Pages.ReferralSources',
            //    'flaticon-more',
            //    '/app/main/workFlow/referralSources'
            //),

            //new AppMenuItem('Referrals', 'Pages.Referrals', 'flaticon-more', '/app/main/referrals/referrals'),

            // new AppMenuItem(
            //    'ReferralContacts',
            //    'Pages.ReferralContacts',
            //    'flaticon-more',
            //    '/app/main/referralContactinfo/referralContacts'
            // ),

            //

            //



            //   path: 'clients/clients',
            //     loadChildren: () => import('./ClientModule/clients/client.module').then((m) => m.ClientModule),
            //     data: { permission: 'Pages.Clients' },
            // },
            //

            //new AppMenuItem('Documents', 'Pages.Documents', 'flaticon-more', '/app/main/documents/documents'),

            //new AppMenuItem(
            //    'ReferralNotes',
            //    'Pages.ReferralNotes',
            //    'flaticon-more',
            //    '/app/main/workFlow/referralNotes'
            //),

            //new AppMenuItem(
            //    'ReferralAllergies',
            //    'Pages.ReferralAllergies',
            //    'flaticon-more',
            //    '/app/main/workFlow/referralAllergies'
            //),

            //new AppMenuItem(
            //    'ReferralMedications',
            //    'Pages.ReferralMedications',
            //    'flaticon-more',
            //    '/app/main/workFlow/referralMedications'
            //),

            //new AppMenuItem(
            //    'ReferralPayers',
            //    'Pages.ReferralPayers',
            //    'flaticon-more',
            //    '/app/main/referralPayers/referralPayers'
            //),

            //new AppMenuItem(
            //    'ReferralSources',
            //    'Pages.ReferralSources',
            //    'flaticon-more',
            //    '/app/main/workFlow/referralSources'
            //),


            // new AppMenuItem(
            //    'ReferralContacts',
            //   'Pages.ReferralContacts',
            //   'flaticon-more',
            //    '/app/main/referralContactinfo/referralContacts'
            // ),

            new AppMenuItem(
                'Administration',
                '',
                'flaticon-interface-8',
                '',
                [],
                [
                    new AppMenuItem(
                        'Organization Units',
                        'Pages.Administration.OrganizationUnits',
                        'la la-building',
                        '/app/admin/organization-units'
                    ),
                    new AppMenuItem('Roles', 'Pages.Administration.Roles', 'la la-shield-alt', '/app/admin/roles'),
                    new AppMenuItem('Users', 'Pages.Administration.Users', 'la la-users', '/app/admin/users'),
                    // new AppMenuItem(
                    //     'Languages',
                    //     'Pages.Administration.Languages',
                    //     'fa fa-language',
                    //     '/app/admin/languages',
                    //     ['/app/admin/languages/{name}/texts']
                    // ),
                    new AppMenuItem(
                        'Payers',
                        'Pages.Administration.Payers',
                        'la la-hand-holding-usd',
                        '/app/admin/administration/payers'
                    ),
                    new AppMenuItem(
                        'Locations',
                        'Pages.Administration.Locations',
                        'la la-map-marker-alt',
                        '/app/admin/locations/locations'
                    ),
                    new AppMenuItem(
                        'Settings',
                        'Pages.Administration.Host.Settings',
                        'la la-cog',
                        '/app/admin/hostSettings'
                    ),
                    new AppMenuItem(
                        'Settings',
                        'Pages.Administration.Tenant.Settings',
                        'la la-cog',
                        '/app/admin/tenantSettings'
                    ),
                    new AppMenuItem('Extension Template', '', 'la la-puzzle-piece', '/app/admin/surveyjseditor'),
                    new AppMenuItem(
                        'Masters',
                        '',
                        'la la-cogs',
                        '',
                        [],
                        [
                            new AppMenuItem(
                                'Organization types',
                                'Pages.Administration.OrganizationTypes',
                                'la la-building',
                                '/app/admin/organizations/organizationTypes'
                            ),
                            new AppMenuItem('Counties', 'Pages.Administration.Counties', 'la la-map-marker', '/app/admin/counties/counties'),
                            new AppMenuItem(
                                'States',
                                'Pages.Administration.States',
                                'la la-flag',
                                '/app/admin/states/state'
                            ),
                            new AppMenuItem(
                                'Countries',
                                'Pages.Administration.Countries',
                                'la la-globe',
                                '/app/admin/countries/country'
                            ),
                            new AppMenuItem(
                                'Document types',
                                'Pages.Administration.Documenttypes',
                                'la la-file-alt',
                                '/app/admin/documenttypes/documenttype'
                            ),
                            new AppMenuItem(
                                'Frequencies',
                                'Pages.Administration.Frequencies',
                                'la la-clock',
                                '/app/admin/doseFrequencies/frequencies'
                            ),
                            new AppMenuItem('Units', 'Pages.Administration.Doseunits', 'la la-pills', '/app/main/workFlow/doseunits'),
                            new AppMenuItem(
                                'Severities',
                                'Pages.Administration.Severities',
                                'la la-exclamation-triangle',
                                '/app/admin/severities/severities'
                            ),
                            new AppMenuItem(
                                'Relationships',
                                'Pages.Administration.Relationships',
                                'la la-users',
                                '/app/main/workFlow/relationships'
                            ),
                            new AppMenuItem(
                                'Specialities',
                                'Pages.Administration.Specialities',
                                'la la-stethoscope',
                                '/app/admin/specialities/Specialities'
                            ),
                        ]
                    ),
                    // new AppMenuItem(
                    //     'Organizations',
                    //     'Pages.Administration.Organizations',
                    //     'fa fa-ellipsis-v',
                    //     '/app/admin/organizations/organizations'
                    // ),
                    // new AppMenuItem(
                    //     'Audit logs',
                    //     'Pages.Administration.AuditLogs',
                    //     'fa fa-history',
                    //     '/app/admin/auditLogs'
                    // ),
                    // new AppMenuItem(
                    //     'Maintenance',
                    //     'Pages.Administration.Host.Maintenance',
                    //     'fa fa-lock',
                    //     '/app/admin/maintenance'
                    // ),
                    // new AppMenuItem(
                    //     'Subscription',
                    //     'Pages.Administration.Tenant.SubscriptionManagement',
                    //     'fa fa-sync-alt',
                    //     '/app/admin/subscription-management'
                    // ),
                    new AppMenuItem(
                        'Visual Settings',
                        'Pages.Administration.UiCustomization',
                        'fa fa-eye',
                        '/app/admin/ui-customization'
                    ),
                    // new AppMenuItem(
                    //     'Webhook Subscriptions',
                    //     'Pages.Administration.WebhookSubscription',
                    //     'fa fa-globe',
                    //     '/app/admin/webhook-subscriptions'
                    // ),
                    // new AppMenuItem(
                    //     'Dynamic Properties',
                    //     'Pages.Administration.DynamicProperties',
                    //     'fa fa-sliders-h',
                    //     '/app/admin/dynamic-property'
                    // ),
                    // new AppMenuItem(
                    //     'Notifications',
                    //     '',
                    //     'fa fa-bell',
                    //     '',
                    //     [],
                    //     [
                    //         new AppMenuItem('Inbox', '', 'fa fa-inbox', '/app/notifications'),
                    //         new AppMenuItem(
                    //             'MassNotifications',
                    //             'Pages.Administration.MassNotification',
                    //             'fa fa-paper-plane',
                    //             '/app/admin/mass-notifications'
                    //         ),
                    //     ]
                    // ),

                ]
            ),

        ]);
    }

    checkChildMenuItemPermission(menuItem): boolean {
        for (let i = 0; i < menuItem.items.length; i++) {
            let subMenuItem = menuItem.items[i];

            // A child with an empty permissionName is NOT a visibility grantor
            // on its own (matches legacy behavior). It may still become visible
            // if a sibling with a real permission causes the parent to display,
            // but it cannot by itself force the parent category open.
            if (subMenuItem.permissionName && this._permissionCheckerService.isGranted(subMenuItem.permissionName)) {
                if (!subMenuItem.hasFeatureDependency()) {
                    return true;
                }

                if (subMenuItem.featureDependencySatisfied()) {
                    return true;
                }
            }

            if (subMenuItem.items && subMenuItem.items.length) {
                let isAnyChildItemActive = this.checkChildMenuItemPermission(subMenuItem);
                if (isAnyChildItemActive) {
                    return true;
                }
            }
        }

        return false;
    }

    showMenuItem(menuItem: AppMenuItem): boolean {
        if (
            menuItem.permissionName === 'Pages.Administration.Tenant.SubscriptionManagement' &&
            this._appSessionService.tenant &&
            !this._appSessionService.tenant.edition
        ) {
            return false;
        }

        let hideMenuItem = false;

        if (menuItem.requiresAuthentication && !this._appSessionService.user) {
            hideMenuItem = true;
        }

        if (menuItem.permissionName && !this._permissionCheckerService.isGranted(menuItem.permissionName)) {
            hideMenuItem = true;
        }

        if (this._appSessionService.tenant || !abp.multiTenancy.ignoreFeatureCheckForHostUsers) {
            if (menuItem.hasFeatureDependency() && !menuItem.featureDependencySatisfied()) {
                hideMenuItem = true;
            }
        }

        if (!hideMenuItem && menuItem.items && menuItem.items.length) {
            return this.checkChildMenuItemPermission(menuItem);
        }

        return !hideMenuItem;
    }


    getAllMenuItems(): AppMenuItem[] {
        let menu = this.getMenu();
        let allMenuItems: AppMenuItem[] = [];
        menu.items.forEach((menuItem) => {
            allMenuItems = allMenuItems.concat(this.getAllMenuItemsRecursive(menuItem));
        });

        return allMenuItems;
    }

    private getAllMenuItemsRecursive(menuItem: AppMenuItem): AppMenuItem[] {
        if (!menuItem.items) {
            return [menuItem];
        }

        let menuItems = [menuItem];
        menuItem.items.forEach((subMenu) => {
            menuItems = menuItems.concat(this.getAllMenuItemsRecursive(subMenu));
        });



        return menuItems;
    }
}
